var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{attrs:{"no-body":""}},[_c('b-tabs',{attrs:{"card":_vm.card},model:{value:(_vm.tabIndex),callback:function ($$v) {_vm.tabIndex=$$v},expression:"tabIndex"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }